import type { ManageAPI } from "~/manage-api/types";
import { anyMatch } from "~/util/store";

export function getStorePagesFromFobs(navItem:NavigationMenuItem, siteGroupings:SiteGroupings | undefined, stores: readonly ManageAPI.Store[], storesPageLink:string, restaurantsPageLink:string ): NavigationMenuItem {
    // Check if the nav item has already been modified, otherwise it concats multiple times
    if(!navItem.isModified) {
        let modifiedItems;
        if (navItem.name.includes('Stores')) {
            if (siteGroupings?.lineOfBusiness.length) {
                let {fieldsOfBusiness} = getFobs(siteGroupings, false, stores, false)
                modifiedItems = fieldsOfBusiness?.map(item => ({
                    link: `${storesPageLink}?fob=${item.name.replace(/\s+/g, '+')}`,
                    url:  `${storesPageLink}?fob=${item.name.replace(/\s+/g, '+')}`,
                    name_i18n: item.name_i18n,
                }));
                navItem.navigationMenuItems = navItem.navigationMenuItems.concat(modifiedItems);
                navItem.isModified = true;
            }
        } else if (navItem.name.includes('Restaurants')) {
            if (siteGroupings?.store.length) {
                let {fieldsOfBusiness} = getFobs(siteGroupings, true, stores, false)
                modifiedItems = fieldsOfBusiness?.map(item => ({
                    link: `${restaurantsPageLink}?fob=${item.name.replace(/\s+/g, '+')}`,
                    url:  `${restaurantsPageLink}?fob=${item.name.replace(/\s+/g, '+')}`,
                    name_i18n: item.name_i18n,
                }));
                navItem.navigationMenuItems = navItem.navigationMenuItems.concat(modifiedItems);
                navItem.isModified = true;
            }
        }
        return navItem;
    } else {
        return navItem;
    }
}

/* Ainoa has a 'Child' category as a Fob that only has store ids (like a restaurant), so
it needs to be handled differently */
export function getFobs(siteGroupings:SiteGroupings | undefined, isRestaurant: boolean, stores: readonly ManageAPI.Store[],  filterOutEmpty?:boolean, scdata?:ManageAPI.ShoppingCenterData ) {
    let fieldsOfBusiness: ManageAPI.Fob[] | Grouping[] = [];
    let fobsByGrouping = false;
    if(siteGroupings?.lineOfBusiness.length && !isRestaurant) {
        let newCat =  undefined;
        fobsByGrouping = true;
        //Filtering out pages that won't have any results in that fob
        fieldsOfBusiness = filterOutEmpty? siteGroupings?.lineOfBusiness.filter(
            anyMatch(stores)
        ): siteGroupings?.lineOfBusiness.filter(el => el.type == 'lineOfBusiness');
        if(siteGroupings?.store?.length){
            newCat = siteGroupings?.store.find(item => item.name.includes('-fob'));
            if (newCat) fieldsOfBusiness.push(newCat);
        }       
        return {fieldsOfBusiness, fobsByGrouping};   
    }
    else if (siteGroupings?.store?.length && isRestaurant) {
        fobsByGrouping = true;
        fieldsOfBusiness = siteGroupings?.store.filter(item => !item.name.includes('-fob'));
        return {fieldsOfBusiness, fobsByGrouping};
    } else {
        fieldsOfBusiness = scdata?.fieldsOfBusiness.filter( 
            anyMatch(stores)
        )
        return {fieldsOfBusiness, fobsByGrouping};
    }
}